module.exports = __webpack_public_path__ + "27192909ec155ab6405346f6fb7c6313.pdf";